<template>
  <div class="content-wrapper">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb
          page-title="Tesorería"
          directory="Confirmar Pago de Proforma"
          :icon="'trello'"
        />
      </div>

      <div class="col-sm-12 col-md-6">
        <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
          <button
            type="button"
            class="btn btn-primary btn-with-shadow"
            @click="returnPage()"
          >
            {{ $t("back") }}
          </button>
        </div>
      </div>
      <!-- <div class="col-12" v-if="evaluationList && evaluationList.length > 0"> -->
      <div class="col-12" v-if="evaluationList && evaluationList.length > 0">
        <app-note
          class="pt-2 clearfix"
          :title="$t('Procesos en bloque')"
          content-type="html"
          note-type="note-warning"
          :notes="[
            $t(
              'Al realizar el ingreso de la información del pago o convenio se efectuará la misma acción para las siguientes evaluaciones o testificaciones'
            ),
          ]"
        />
      </div>
      <br />
      <div class="col-12" v-if="evaluationList && evaluationList.length > 0">
        <table class="table table-sm table-striped">
          <thead>
            <tr>
              <th scope="col">Expediente</th>
              <th scope="col">Tipo</th>
              <th scope="col">Código</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(value, key) in evaluationList" :key="key">
              <td class="align-middle">
                {{ value.accreditation_applications.record }}
              </td>
              <td class="align-middle">
                <br />
                <p v-if="value.type == 'E'">Evaluación</p>
                <p v-if="value.type == 'T'">Testificación</p>
              </td>
              <td class="align-middle">{{ value.code }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- </div> -->

      <div class="col-12" v-if="observations.length > 0">
        <div class="form-group">
          <legend>
            <label class="text-primary">Observaciones</label>
          </legend>
          <table class="table table-sm table-striped">
            <thead>
              <tr>
                <th scope="col">OBSERVACIÓN</th>
                <th scope="col" class="text-center" style="width: 20%">
                  USUARIO
                </th>
                <th scope="col" class="text-center" style="width: 15%">
                  FECHA
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(value, obs) in observations" :key="obs">
                <td>{{ value.observation }}</td>
                <td class="text-center">
                  {{ value.user ? value.user.full_name : "" }}
                </td>
                <td class="text-center">{{ value.created_at | dateFormat }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="col-sm-12">
        <app-overlay-loader v-if="preloader" />
        <form
          class="mb-0"
          :class="{ 'loading-opacity': preloader }"
          ref="form"
          data-url="/accreditations/process/quotation/payment"
        >
         <!-- <div class="form-group row align-items-center">
            <label class="col-sm-3 mb-0">Es Convenio</label>
            <br />
            <app-input
              class="col-sm-12"
              type="radio-buttons"
              v-model="inputs.is_agreement"
              :list="confirm"
            />
          </div> -->
          <br />
          <div class="row">
            <div class="col-12">
              <app-note
                class="mb-2"
                note-type="note-red"
                :show-title="false"
                :notes="formNoteInstruction"
              />
            </div>
          </div>
          <br />
          <div>
            <div class="row" v-if="!inputs.is_agreement">
              <div class="col-md-12">
                <legend>
                  <p class="text-primary">DATOS PARA FACTURACIÓN</p>
                </legend>
              </div>

              <!-- <div class="col-3" v-if="showInputDataFull">
                <div class="form-group">
                  <label>¿Mismos datos que la solicitud?</label>
                  <app-input
                    type="select"
                    v-model="same_data"
                    :list="confirm"
                    @change="same($event)"
                  />
                </div>
              </div> -->

              <!-- <div class="col-4" v-if="showInputDataFull2">
                <div class="form-group">
                  <label>¿Mismos datos que la solicitud inicial?</label>
                  <app-input
                      type="select"
                      v-model="same_data"
                      :list="confirm"
                      @change="sameVigilance($event)"
                  />
                </div>
              </div> -->


              <div class="col-9"></div>

              <div class="col-md-6">
                <div class="form-group">
                  <label
                    >Razón Social
                    <b class="text-danger" style="font-size: 18px !important"
                      >*</b
                    ></label
                  >
                  <app-input
                    type="text"
                    v-model="inputs.i_business_name"
                    :required="true"
                    :disabled="disabled"
                    placeholder="Ingrese el nombre o razón social"
                  />
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label
                    >RUC
                    <b class="text-danger" style="font-size: 18px !important"
                      >*</b
                    ></label
                  >
                  <app-input
                    type="text"
                    v-model="inputs.i_taxid"
                    :required="true"
                    :disabled="disabled"
                    placeholder="Ingrese el RUC"
                  />
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label
                    >País
                    <b class="text-danger" style="font-size: 18px !important"
                      >*</b
                    ></label
                  >
                  <app-input
                    type="select"
                    v-model="inputs.i_country_id"
                    :list="[
                      { id: '', value: this.$t('select_option') },
                      ...this.$store.state.common.countries,
                    ]"
                    :required="true"
                    :disabled="disabled"
                  />
                </div>
              </div>

              <div
                class="col-md-6"
                v-if="inputs.i_country_id && provinceList.length <= 1"
              >
                <div class="form-group">
                  <label
                    >Ciudad<b
                      class="text-danger ml-2"
                      style="font-size: 18px !important"
                      >*</b
                    ></label
                  >
                  <app-input
                    type="text"
                    v-model="inputs.i_city"
                    placeholder="Ingrese la ciudad"
                    :required="true"
                    :disabled="disabled"
                  />
                </div>
              </div>

              <div class="col-md-6" v-if="provinceList.length > 1">
                <div class="form-group">
                  <label
                    >Provincia<b
                      class="text-danger ml-2"
                      style="font-size: 18px !important"
                      >*</b
                    ></label
                  >
                  <app-input
                    type="select"
                    v-model="inputs.i_province_id"
                    :list="[
                      { id: '', value: this.$t('select_option') },
                      ...provinceList,
                    ]"
                    :required="true"
                    :disabled="disabled"
                  />
                </div>
              </div>

              <div class="col-md-6" v-if="provinceList.length > 1">
                <div class="form-group">
                  <label
                    >Ciudad<b
                      class="text-danger ml-2"
                      style="font-size: 18px !important"
                      >*</b
                    ></label
                  >
                  <app-input
                    type="select"
                    v-model="inputs.i_canton_id"
                    :list="[
                      { id: '', value: this.$t('select_option') },
                      ...cantonList,
                    ]"
                    :required="true"
                    :disabled="disabled"
                    placeholder="Ingrese la ciudad"
                  />
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label
                    >E-mail
                    <b class="text-danger" style="font-size: 18px !important"
                      >*</b
                    ></label
                  >
                  <app-input
                    type="email"
                    v-model="inputs.i_email"
                    placeholder="Ingrese su email"
                    :required="true"
                    :disabled="disabled"
                  />
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label
                    >Teléfono
                    <b class="text-danger" style="font-size: 18px !important"
                      >*</b
                    ></label
                  >
                  <app-input
                    type="tel-input"
                    v-model="inputs.i_phone"
                    :required="true"
                    :disabled="disabled"
                    placeholder="Ingrese el teléfono"
                  />
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label
                    >Dirección
                    <b class="text-danger" style="font-size: 18px !important"
                      >*</b
                    ></label
                  >
                  <app-input
                    type="textarea"
                    v-model="inputs.i_address"
                    :required="true"
                    :disabled="disabled"
                    placeholder="Ingrese la dirección"
                  />
                </div>
              </div>
            </div>
          </div>

          <div v-if="!inputs.is_agreement">
            <br />
            <div class="row">
              <div class="col-sm-12">
                <table
                  class="table table-sm table-striped"
                  v-if="inputs.evaluation_team_file"
                >
                  <thead>
                    <tr>
                      <th scope="col">NOMBRE</th>
                      <th>FECHA DE CREACIÓN</th>
                      <th scope="col" class="text-center" style="width: 10%">
                        ACCIÓN
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="inputs.evaluation_team_file">
                      <td class="align-middle">
                        Propuesta del Equipo Evaluador
                      </td>
                      <td class="align-middle">
                        {{
                          inputs.evaluation_team_file.created_at | dateFormat
                        }}
                      </td>
                      <td class="align-middle text-center">
                        <a
                          :href="
                            inputs && inputs.evaluation_team_file
                              ? inputs.evaluation_team_file.full_url
                              : ''
                          "
                          class="btn btn-success btn-md"
                          target="_blank"
                        >
                          <app-icon name="file"></app-icon> Ver
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>

                <br /><br />
                <table
                  class="table table-sm table-striped"
                  v-if="inputs.evaluation_team_file"
                >
                  <thead>
                    <tr>
                      <th scope="col">NOMBRE</th>
                      <th>FECHA DE CREACIÓN</th>
                      <th scope="col" class="text-center" style="width: 10%">
                        ACCIÓN
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="inputs.proforma">
                      <td class="align-middle">Proforma de Servicios</td>
                      <td class="align-middle">
                        {{ inputs.proforma.created_at | dateFormat }}
                      </td>
                      <td class="align-middle text-center">
                        <a
                          :href="
                            inputs && inputs.proforma
                              ? inputs.proforma.full_url
                              : ''
                          "
                          class="btn btn-success btn-md"
                          target="_blank"
                        >
                          <app-icon name="file"></app-icon> Ver
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="col-12 my-3">
                <div class="form-group">
                  <legend>
                    <p class="text-primary">FORMAS DE PAGO</p>
                  </legend>
                  <app-input
                    type="radio-buttons"
                    :list="isPay"
                    v-model="inputs.pay_with"
                  />
                </div>
              </div>

              <!-- <div class="col-md-12">
                <legend>
                  <p class="text-primary">DATOS PARA EL PAGO</p>
                </legend>
              </div> -->

              <div class="col-12 mb-4" v-if="inputs.pay_with">
                <button
                  class="btn btn-primary mr-2"
                  @click.prevent="openCheckout(evaluationId, inputs, $toastr, 0)"
                >
                  Pago corriente
                </button>
                <button
                  class="btn btn-primary mr-2"
                  @click.prevent="openCheckout(evaluationId, inputs, $toastr, 2)"
                >
                  Pago diferido
                </button>
              </div>

              <div class="col-sm-6" v-if="!inputs.pay_with">
                <div class="form-group">
                  <label for="inputs_name" class="col-sm-12 mb-0"
                    >Banco
                    <b class="text-danger" style="font-size: 18px !important"
                      >*</b
                    ></label
                  >
                  <app-input
                    id="inpbank_id"
                    class="col-sm-12"
                    type="select"
                    v-on:change="handleBlur"
                    v-model="inputs.bank_id"
                    :list="bankList"
                    :required="true"
                  />
                </div>
              </div>
              <div class="col-sm-6" v-if="!inputs.pay_with">
                <div class="form-group">
                  <label for="inputs_name" class="col-sm-12 mb-0">
                    Tipo transacción
                    <b class="text-danger" style="font-size: 18px !important"
                      >*</b
                    >
                  </label>
                  <app-input
                    id="inpbank_id"
                    class="col-sm-12"
                    type="select"
                    v-model="inputs.transaction_type_id"
                    :list="transactionTypeList"
                    :required="true"
                  />
                </div>
              </div>
            </div>

            <div class="mb-primary" v-if="!inputs.pay_with">
              <app-note
                class="pt-2 clearfix"
                title="Nota"
                content-type="html"
                note-type="note-warning"
                :notes="[
                  $t(
                    'SE ACEPTARAN ÚNICAMENTE PAGOS EN EFECTIVO (INCLUYE USO DE CHEQUES CERTIFICADOS O DE GERENCIA) Y CON TRANSFERENCIA. EL PAGO DEBE REALIZARSE POR EL VALOR TOTAL Y EXACTO DE LA PROFORMA.'
                  ),
                ]"
              />
            </div>

            <div class="form-group row align-items-center" v-if="!inputs.pay_with">
              <div class="col-sm-6">
                <label for="inputs_name" class="col-sm-12 mb-0">
                  Nro transacción
                  <b class="text-danger" style="font-size: 18px !important"
                    >*</b
                  >
                </label>
                <app-input
                  class="col-sm-12"
                  type="text"
                  v-model="inputs.number"
                  :required="true"
                  placeholder="Ingrese número de transacción"
                />
                <span class="text-danger" v-if="msgNumber">
                  {{ msgNumber }}</span
                >
              </div>
              <div class="col-sm-6">
                <label for="inputs_name" class="col-sm-12 mb-0"
                  >Valor
                  <b class="text-danger" style="font-size: 18px !important"
                    >*</b
                  ></label
                >
                <app-input
                  class="col-sm-12"
                  type="number"
                  v-model="inputs.amount"
                  :required="true"
                  placeholder="Ingrese valor del comprobante"
                />
              </div>
            </div>

            <div class="form-group row align-items-center" v-if="!inputs.pay_with">
              <div class="col-sm-6">
                <label for="inputs_name" class="col-sm-12 mb-0"
                  >Fecha
                  <b class="text-danger" style="font-size: 18px !important"
                    >*</b
                  ></label
                >
                <app-input
                  class="col-sm-12"
                  type="date"
                  v-model="inputs.date"
                  :required="true"
                />
              </div>
            </div>
          </div>

          <div class="form-group row align-items-center" v-if="!inputs.pay_with">
            <div class="col-12">
              <div class="form-group">
                <p class="card-title m-0">
                  <strong>{{
                    inputs.is_agreement ? "Convenio" : "Comprobante de Pago"
                  }}</strong>
                  <b class="text-danger" style="font-size: 18px !important"
                    >*</b
                  >
                </p>
                <br />
                <app-input
                  type="file"
                  :label="depositFile"
                  v-model="inputs.attach_deposit"
                  v-on:change="fileChoosen"
                  :required="true"
                />
                <small class="form-text text-danger"
                  >Archivo .pdf del MAX 8MB</small
                >
              </div>
            </div>
          </div>
        </form>
        <div v-if="inputs.eval_annexes_files && inputs.eval_annexes_files.length > 0">
          <legend
          >
            <p class="text-primary">ANEXOS DE HONORARIOS DE PERSONAL EXTERNO</p>
          </legend>
          <hr />
          <table
            class="table table-sm table-striped"
            v-if="!inputs.is_agreement && inputs.eval_annexes_files.length > 0"
          >
            <thead>
              <tr>
                <th scope="col">NOMBRE</th>
                <th>FECHA DE CREACIÓN</th>
                <th scope="col" class="text-center" style="width: 10%">
                  ACCIÓN
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, key) in inputs.eval_annexes_files" :key="key">
                <td class="align-middle">{{ item.filename }}</td>
                <td class="align-middle">
                  {{ item.created_at | dateFormat }}
                </td>
                <td class="align-middle text-center">
                  <a
                    :href="item.annexed.full_url"
                    class="btn btn-success btn-md"
                    target="_blank"
                  >
                    <app-icon name="file"></app-icon> Ver
                  </a>
                </td>
              </tr>
              <tr v-for="ext in inputs.evaluation_team" :key="ext.id">
                <td class="align-middle" v-if="ext.evaluation_team_external">
                  {{
                      ext.evaluator
                        ? `${ext.evaluator.first_name} ${ext.evaluator.last_name}`
                        : ""
                  }}
                </td>
                <td class="align-middle" v-if="ext.evaluation_team_external">
                  {{ ext.evaluation_team_external.created_at | dateFormat }}
                </td>
                <td class="align-middle text-center" v-if="ext.evaluation_team_external">
                  <button type="submit" class="btn btn-success" @click.prevent="openTabExt(ext,'evaluation_team_external')">
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>

          <!-- <legend v-if="!inputs.is_agreement">
            <p class="text-primary">Comprobantes de pagos personal externo</p>
          </legend> -->

          <!-- <div class="row" v-if="!inputs.is_agreement">
            <div class="col-12">
              <div
                class="row mb-2"
                v-for="(vj, j) in external_personal_payment_vouchers"
                :key="j"
              >
                <div class="col-12 col-md-5">
                  <app-input
                    :id="`filename_${j}`"
                    type="text"
                    v-model="vj.filename"
                    placeholder="Descripcion del archivo"
                    @keyup="onKeyUpVoucher(j)"
                  />
                </div>

                <div class="col-12 col-md-5" v-if="!vj.annexed">
                  <app-input
                    :id="`file_${j}`"
                    type="file"
                    :label="vj.file ? vj.file.name : $t('upload_your_file')"
                    v-model="vj.file"
                    @change="onChangeVoucher($event, j)"
                  />
                  <small v-if="!vj.annexed" class="text-center text-danger"
                    >Tamaño máximo del archivo 8 Mb</small
                  >
                </div>

                <div class="col-12 col-md-2 text-center" v-if="!vj.annexed">
                  <button
                    type="submit"
                    class="btn btn-warning"
                    @click="removeRowFileVoucher(j)"
                    v-if="!vj.annexed"
                  >
                    Quitar
                  </button>
                </div>

                <div class="col-12 col-md-6 text-center" v-if="vj.annexed">
                  <button
                    type="submit"
                    class="btn btn-success"
                    @click.prevent="openTab(vj.annexed)"
                  >
                    <app-icon name="file" /> Ver
                  </button>

                  <button
                    type="submit"
                    class="btn btn-danger"
                    @click.prevent="openDeleteModal(j, vj)"
                  >
                    <app-icon name="trash-2" /> Eliminar
                  </button>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-12">
                  <button
                    type="submit"
                    class="btn btn-primary"
                    @click="addFileVoucher()"
                  >
                    <app-icon name="plus" /> Agregar archivo
                  </button>
                </div>
              </div>
            </div>
          </div> -->

          <!-- <br />
          <legend v-if="!inputs.is_agreement">
            <p class="text-primary">Facturas de pago personal externo</p>
          </legend> -->

          <!-- <div class="row" v-if="!inputs.is_agreement">
            <div class="col-12">

              <div
                class="row mb-2"<div
          class="row"
          v-if="evaluationList && evaluationList.length > 0"
        >
          <div class="col-12">
            <app-note
              class="pt-2 clearfix"
              :title="$t('Procesos en bloque')"
              content-type="html"
              note-type="note-warning"
              :notes="[
                $t(
                  'Al realizar o no la aprobación de la propuesta de equipo evaluador se efectuará la misma acción para las siguientes evaluaciones o testificaciones'
                ),
              ]"
            />
          </div>
          <br />
          <div class="col-12">
            <table class="table table-sm table-striped">
              <thead>
                <tr>
                  <th scope="col">Expediente</th>
                  <th scope="col">Tipo</th>
                  <th scope="col">Código</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(value, key) in evaluationList" :key="key">
                  <td class="align-middle">
                    {{ value.accreditation_applications.record }}
                  </td>
                  <td class="align-middle">
                    <br />
                    <p v-if="value.type == 'E'">Evaluación</p>
                    <p v-if="value.type == 'T'">Testificación</p>
                  </td>
                  <td class="align-middle">{{ value.code }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
                v-for="(vj, j) in external_personal_payment_invoices"
                :key="j"
              >
                <div class="col-12 col-md-5">
                  <app-input
                    :id="`filename_${j}`"
                    type="text"
                    v-model="vj.filename"
                    placeholder="Descripcion del archivo"
                    @keyup="onKeyUpInvoice(j)"
                  />
                </div>

                <div class="col-12 col-md-5" v-if="!vj.annexed">
                  <app-input
                    :id="`file_${j}`"
                    type="file"
                    :label="vj.file ? vj.file.name : $t('upload_your_file')"
                    v-model="vj.file"
                    @change="onChangeInvoice($event, j)"
                  />
                  <small v-if="!vj.annexed" class="text-center text-danger"
                    >Tamaño máximo del archivo 8 Mb</small
                  >
                </div>

                <div class="col-12 col-md-2 text-center" v-if="!vj.annexed">
                  <button
                    type="submit"
                    class="btn btn-warning"
                    @click="removeRowFileInvoice(j)"
                    v-if="!vj.annexed"
                  >
                    Quitar
                  </button>
                </div>

                <div class="col-12 col-md-6 text-center" v-if="vj.annexed">
                  <button
                    type="submit"
                    class="btn btn-success"
                    @click.prevent="openTab(vj.annexed)"
                  >
                    <app-icon name="file" /> Ver
                  </button>

                  <button
                    type="submit"
                    class="btn btn-danger"
                    @click.prevent="openDeleteModal(j, vj)"
                  >
                    <app-icon name="trash-2" /> Eliminar
                  </button>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-12">
                  <button
                    type="submit"
                    class="btn btn-primary"
                    @click="addFileInvoice()"
                  >
                    <app-icon name="plus" /> Agregar archivo
                  </button>
                </div>
              </div>
            </div>
          </div>
          <br /> -->
          <br />
        </div>
        <button type="submit" class="btn btn-primary" @click.prevent="submit" v-if="!inputs.pay_with">
          Guardar
        </button>
      </div>
    </div>

    <app-confirmation-modal
      v-if="deleteModal"
      modal-id="delete"
      @confirmed="confirmed"
      @cancelled="cancelled"
    />
  </div>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import { ModalMixin } from "@/app/Mixins/ModalMixin";
import * as actions from "../../../../apiUrl";
import { axiosPost, axiosDelete } from "@/app/helpers/AxiosHelper";

export default {
  name: "ProformaPaymentModal",
  mixins: [FormMixin, ModalMixin],
  props: {
    evaluationId: String,
  },

  computed: {
    disabled() {
      return false;
    },
  },
  watch: {
    "inputs.i_country_id": function () {
      this.provinceList = this.$store.getters.getProvinces(
        this.inputs.i_country_id
      );
    },

    "inputs.i_province_id": function () {
      this.cantonList = this.$store.getters.getCantons(
        this.inputs.i_province_id
      );
    },

    "$store.state.common.countries": function () {
      if (this.inputs.i_country_id) {
        this.provinceList = this.$store.getters.getProvinces(
          this.inputs.i_country_id
        );
        this.cantonList = this.$store.getters.getCantons(
          this.inputs.org.i_province_id
        );
      }
    },

    // same_data: function (value) {
    //   if (value) {
    //     this.inputs.i_business_name = this.deposit.i_business_name;
    //     this.inputs.i_taxid = this.deposit.i_taxid;
    //     this.inputs.i_country_id = this.deposit.i_country_id;
    //     this.inputs.i_city = this.deposit.i_city;
    //     this.inputs.i_province_id = this.deposit.i_province_id;
    //     this.inputs.i_canton_id = this.deposit.i_canton_id;
    //     this.inputs.i_email = this.deposit.i_email;
    //     this.inputs.i_phone = this.deposit.i_phone;
    //     this.inputs.i_address = this.deposit.i_address;
    //   } else {
    //     this.inputs.i_business_name = null;
    //     this.inputs.i_taxid = null;
    //     this.inputs.i_country_id = null;
    //     this.inputs.i_country_id = null;
    //     this.inputs.i_city = null;
    //     this.inputs.i_province_id = null;
    //     this.inputs.i_canton_id = null;
    //     this.inputs.i_email = null;
    //     this.inputs.i_address = null;
    //   }
    // },
  },

  filters: {
    dateFormat: function (value) {
      if (value) {
        return moment(value).format("YYYY-MM-DD HH:mm");
      }
    },
  },
  data() {
    return {
      preloader: false,
      deleteModal: false,
      requiredAnnexes: false,
      formNoteInstruction: [
        this.$t("Todos los campos con un (*) son obligatorios."),
      ],
      evaluationList: "",
      bankList: [],
      transactionTypeList: [],
      external_personal_payment_invoices: [],
      external_personal_payment_vouchers: [],
      tmp: {},
      delayTimer: null,
      showInputDataFull: false,
      showInputDataFull2: false,
      inputs: {
        is_agreement: 0,
        pay_with: 0,
        proform_generated: [],
        eval_annexes_files:"",
        evaluation_team:"",
      },
      msgNumber: "",
      depositFile: "Seleccionar Archivo",
      feeFile: "Seleccionar Archivo",
      modalId: "proforma-paym-modal",
      modalTitle: this.$t("Registrar comprobante de pago de Proforma"),
      fee: [
        {
          id: 0,
          value: "NO",
        },
        {
          id: 1,
          value: "SI",
        },
      ],
      confirm: [
        {
          id: 0,
          value: "NO",
        },
        {
          id: 1,
          value: "SI",
        },
      ],
      isPay: [
        {
          id: 0,
          value: "Pago con transferencia / depósito",
        },
        {
          id: 1,
          value: "Pago con tarjeta",
        },
      ],
      provinceList: [],
      cantonList: [],
      taxid: true,
      same_data: 0,
      deposit: {},
      observations: [],
      accId: null,
      depositVigilance: null,
      paymentCheckout: null,
      btnOpenCheckout: null,
    };
  },

  created() {
    this.inputs.date = new Date();
    // this.inputs.i_country_id = 1
    this.bankInfo();
    this.getObservations();
    this.getInfo();

    const script = document.createElement('script')
    script.src= 'https://code.jquery.com/jquery-3.5.0.min.js'
    // script.src= 'https://cdn.paymentez.com/ccapi/sdk/payment_checkout_stable.min.js'
    script.src= 'https://cdn.paymentez.com/ccapi/sdk/payment_checkout_3.0.0.min.js'
    //script.onload = () => this.initPaymentez()
    document.body.appendChild(script)
  },
  methods: {
    returnPage() {
      window.history.back();
    },

    same() {
      if (this.same_data == 1) {
        this.inputs.i_business_name = this.deposit.i_business_name;
        this.inputs.i_taxid = this.deposit.i_taxid;
        this.inputs.i_country_id = this.deposit.i_country_id;
        this.inputs.i_city = this.deposit.i_city;
        this.inputs.i_province_id = this.deposit.i_province_id;
        this.inputs.i_canton_id = this.deposit.i_canton_id;
        this.inputs.i_email = this.deposit.i_email;
        this.inputs.i_phone = this.deposit.i_phone;
        this.inputs.i_address = this.deposit.i_address;
        this.provinceList = this.$store.getters.getProvinces(
          this.inputs.i_country_id
        );
        this.cantonList = this.$store.getters.getCantons(
          this.inputs.i_province_id
        );
      } else {
        this.inputs.i_business_name = null;
        this.inputs.i_taxid = null;
        this.inputs.i_country_id = null;
        this.inputs.i_country_id = null;
        this.inputs.i_city = null;
        this.inputs.i_province_id = null;
        this.inputs.i_canton_id = null;
        this.inputs.i_email = null;
        this.inputs.i_address = null;
        this.inputs.date = new Date();
      }
    },
    sameVigilance(){
      if (this.same_data == 1) {
        this.inputs.i_business_name = this.depositVigilance.i_business_name;
        this.inputs.i_taxid = this.depositVigilance.i_taxid;
        this.inputs.i_country_id = this.depositVigilance.i_country_id;
        this.inputs.i_city = this.depositVigilance.i_city;
        this.inputs.i_province_id = this.depositVigilance.i_province_id;
        this.inputs.i_canton_id = this.depositVigilance.i_canton_id;
        this.inputs.i_email = this.depositVigilance.i_email;
        this.inputs.i_phone = this.depositVigilance.i_phone;
        this.inputs.i_address = this.depositVigilance.i_address;
        this.provinceList = this.$store.getters.getProvinces(
            this.inputs.i_country_id
        );
        this.cantonList = this.$store.getters.getCantons(
            this.inputs.i_province_id
        );
      }else{
        this.inputs.i_business_name = null;
        this.inputs.i_taxid = null;
        this.inputs.i_country_id = null;
        this.inputs.i_country_id = null;
        this.inputs.i_city = null;
        this.inputs.i_province_id = null;
        this.inputs.i_canton_id = null;
        this.inputs.i_email = null;
        this.inputs.i_address = null;
        this.inputs.date = new Date();
      }
    },
    bankInfo() {
      this.preloader = true;
      let url = `${actions.ACCREDITATION_PROCESS}/options`;
      this.axiosGet(url)
        .then((response) => {
          if (response.status == 200) {
            this.bankList = [
              { id: "", value: "Seleccione Banco" },
              ...response.data.bank,
            ];
            this.transactionTypeList = [
              { id: "", value: "Seleccione Transacción" },
              ...response.data.transactiontype,
            ];
          }
        })
        .catch(({ error }) => {
          console.log(error);
        })
        .finally(() => {
          this.preloader = false;
        });
    },

    getInfoVigilances(accType = ''){
      if (accType == 'Vigilancia 1' || accType == 'Vigilancia 2' || accType == 'Vigilancia 3' || accType == 'Renovación'){
        const url = `${actions.ACCREDITATION_PROCESS}/get_info_acc_parent/${this.accId}`;
        this.preloader = true;
        this.axiosGet(url).then((response)=>{
          this.depositVigilance = response.data;
          this.showInputDataFull2 = true;
          this.preloader = false;
        })
      }

    },

    getInfo() {
      this.$store.dispatch("getPoliticalDivision");
      this.preloader = true;
      let url = `${actions.ACCREDITATION_PROCESS}/quotation/${this.evaluationId}?status=204`;
      this.axiosGet(url)
        .then((response) => {
          if (response.status == 200) {
            /* if (response.data.proforma) {
              this.inputs = response.data;
              this.external_personal_payment_invoices =
                this.inputs.external_personal_payment_invoices;
              this.external_personal_payment_vouchers =
                this.inputs.external_personal_payment_vouchers;
            } */
           this.inputs.eval_annexes_files = response.data.eval_annexes_files;
           this.inputs.evaluation_team = response.data.evaluation_team;
           
            var accType = response.data.accreditationType.name; 
            if(accType.match(/Acreditación Inicial*/) || accType.match(/Ampliación*/) ){
              this.showInputDataFull = true;
            }
            if (response.data.deposit) {
              this.deposit = response.data.deposit;
            }
            if (response.data.proforma_additional_file) {
              this.requiredAnnexes = true;
              this.inputs.proforma_additional_file =
                response.data.proforma_additional_file;
            }

            if (
              response.data.evaluationList &&
              response.data.evaluationList.length > 0
            ) {
              this.evaluationList = response.data.evaluationList;
            }
            if (response.data.proform_generated) {
              this.inputs.proform_generated.id = response.data.proform_generated.id;
              this.inputs.proform_generated.total = response.data.proform_generated.total;
            }
            this.accId = response.data.accreditation_id;
            this.getInfoVigilances(accType);
          }
        })
        .catch(({ error }) => {
          console.log(error);
        })
        .finally(() => {
          this.preloader = false;
        });
    },

    handleBlur(e) {
      if (this.inputs.number && this.inputs.bank_id) {
        this.preloader = true;
        let number = this.inputs.number;
        let url = `${actions.TREASURY}/validateDeposit/${this.inputs.number}/${this.inputs.bank_id}`;
        this.axiosGet(url)
          .then((response) => {
            if (response.status == 200) {
              if (!response.data.validate) {
                this.inputs.number = null;
                this.msgNumber =
                  "Comprobante " + number + " ya esta registrado";
              } else {
                this.msgNumber = "";
              }
            }
          })
          .catch(({ error }) => {
            console.log(error);
          })
          .finally(() => {
            this.preloader = false;
          });
      }
    },
    fileChoosen(event) {
      if (event.target.files[0].type === "application/pdf") {
        if (event.target.files[0].size < 8388608) {
          this.depositFile = event.target.files[0].name;
        } else {
          this.$toastr.e("El archivo PDF no debe exceder los 8MB.");
        }
      } else {
        this.$toastr.e("Solo permitidos archivos .pdf");
      }
    },
    fileChoosenFee(event) {
      if (event.target.files[0].size < 8388608) {
        this.feeFile = event.target.files[0].name;
      } else {
        this.$toastr.e("El archivo no debe exceder los 8MB.");
      }
    },
    submit() {
      const tmp = { ...this.inputs };
      const d = tmp.date;
      if (tmp.date) {
        tmp.date = [d.getFullYear(), d.getMonth() + 1, d.getDate()].join("-");
      }
      tmp.eval_test_id = this.evaluationId;
      let formData = new FormData();
      for (const [key, value] of Object.entries(tmp)) {
        if (value != null) formData.append(key, value);
      }
      this.save(formData);
    },
    afterSuccess() {
      this.$toastr.s("Su solicitud ha sido enviada a revisión.");
      window.location.href =
        "/accreditations/process/quotation?tab=Confirmar%20Pago%20Proforma";
    },

    onKeyUp() {
      if (this.inputs.bank_id != null && this.inputs.number != null) {
        clearTimeout(this.delayTimer);
        this.delayTimer = setTimeout(this.ckeck, 1000);
      } else {
        this.msgNumber = null;
      }
    },

    ckeck() {
      this.msgNumber = "";
      clearTimeout(this.delayTimer);
      const url = `treasury/deposits/validateDeposit/${this.inputs.number}/${this.inputs.bank_id}`;
      this.axiosGet(url).then((response) => {
        if (response.status == 200) {
          const { validate } = response.data;
          if (validate) {
            this.msgNumber = "Comprobante valido";
            this.classes = "text-success";
          } else {
            this.msgNumber = "Comprobante registrado";
            this.classes = "text-danger";
          }
        }
      });
    },

    dateToString(date) {
      return date != null ? moment(date).format("YYYY-MM-DD") : null;
    },

    onChangeTaxid() {
      clearTimeout(this.delayTimer);
      this.delayTimer = setTimeout(() => {
        this.inputs.i_taxid = this.inputs.i_taxid.split(" ").join("");
        if (!this.inputs.i_taxid || this.inputs.i_taxid.length != 13) {
          this.$toastr.e("El campo RUC es obligatorio y debe tener 13 digitos");
          return;
        }
        this.validateTaxid(this.inputs.i_taxid);
      }, 1000);
    },
    validateTaxid(taxid) {
      this.preloader = true;
      let url = `/register/users/validateRucPayment/${taxid}`;
      this.axiosGet(url)
        .then((response) => {
          if (response.status == 200) {
            if (!response.data.validate) {
              this.$toastr.e(response.data.message);
            }

            this.i_taxid = response.data.validate;
          }
        })
        .catch(({ error }) => {
          console.log(error);
        })
        .finally(() => {
          this.preloader = false;
        });
    },
    getObservations() {
      let url = `/common/observations?evalTestId=${this.evaluationId}&status=204`;
      this.axiosGet(url).then((response) => {
        this.observations = response.data;
      });
    },

    addFileInvoice() {
      if (this.external_personal_payment_invoices.length >= 15) {
        this.$toastr.e("Solo se pueden adjuntar un maximo de 15 archivos");
        return;
      }
      this.external_personal_payment_invoices.push({
        record_id: this.inputs.id,
        filename: null,
        file: null,
      });
    },

    addFileVoucher() {
      if (this.external_personal_payment_vouchers.length >= 15) {
        this.$toastr.e("Solo se pueden adjuntar un maximo de 15 archivos");
        return;
      }
      this.external_personal_payment_vouchers.push({
        record_id: this.inputs.id,
        filename: null,
        file: null,
      });
    },

    openTab(file) {
      const w = window.open(file.path, "_blank");
      w.focus();
    },

    openDeleteModal(j, vj) {
      this.deleteModal = true;
      this.tmp = {
        j: j,
        vj: vj,
      };
    },

    removeRowFileInvoice(j) {
      this.external_personal_payment_invoices =
        this.external_personal_payment_invoices.filter(
          (value, index) => index != j
        );
    },

    removeRowFileVoucher(j) {
      this.external_personal_payment_vouchers =
        this.external_personal_payment_vouchers.filter(
          (value, index) => index != j
        );
    },

    cancelled() {
      this.deleteModal = false;
    },

    onChangeInvoice(e, j) {
      const tmp = this.external_personal_payment_invoices[j];
      if (!tmp.file) return;

      if (tmp.file.size > 8700000) {
        this.$set(this.external_personal_payment_invoices[j], "file", null);
        this.$set(this.external_personal_payment_invoices[j], "filename", null);
        this.$toastr.e("El tamaño maximo permitido por archivo es de 8MB");
        return;
      }

      if (!tmp.filename)
        this.$set(
          this.external_personal_payment_invoices[j],
          "filename",
          e.target.files[0].name
        );
      this.chargeFile(j);
    },

    onChangeVoucher(e, j) {
      const tmp = this.external_personal_payment_vouchers[j];
      if (!tmp.file) return;

      if (tmp.file.size > 8700000) {
        this.$set(this.external_personal_payment_vouchers[j], "file", null);
        this.$set(this.external_personal_payment_vouchers[j], "filename", null);
        this.$toastr.e("El tamaño maximo permitido por archivo es de 8MB");
        return;
      }
      if (!tmp.filename)
        this.$set(
          this.external_personal_payment_vouchers[j],
          "filename",
          e.target.files[0].name
        );
      this.chargeFileVoucher(j);
    },

    onKeyUpInvoice(j) {
      const tmp = this.external_personal_payment_invoices[j];
      if (!tmp.filename || tmp.filename.length == 0) return;
      clearTimeout(this.delayTimer);
      this.delayTimer = setTimeout(() => this.chargeFile(j), 1000);
    },

    onKeyUpVoucher(j) {
      const tmp = this.external_personal_payment_vouchers[j];
      if (!tmp.filename || tmp.filename.length == 0) return;
      clearTimeout(this.delayTimer);
      this.delayTimer = setTimeout(() => this.chargeFileVoucher(j), 1000);
    },

    chargeFile(j) {
      this.deleteLoader = true;
      const url = `${actions.ACCREDITATION_PROCESS}/addFileInvoice`;
      const tmpo = this.external_personal_payment_invoices[j];
      let formData = new FormData();
      for (const [key, value] of Object.entries(
        this.external_personal_payment_invoices[j]
      )) {
        formData.append(key, value);
      }
      axiosPost(url, formData)
        .then((res) => {
          this.deleteLoader = false;
          if (tmpo.file) {
            const data = res.data.data[res.data.data.length - 1];
            const tmp = [...this.external_personal_payment_invoices];
            tmp[j] = data;
            this.external_personal_payment_invoices = tmp;
          }
        })
        .catch(({ error }) => {});
    },

    confirmed() {
      const url = `${actions.ACCREDITATION_PROCESS}/destroyFile?eval_annexed_id=${this.tmp.vj.record_id}&id=${this.tmp.vj.id}&type=${this.tmp.vj.type}`;
      axiosDelete(url)
        .then((res) => {
          this.deleteModal = false;
          this.deleteLoader = false;
          const { data } = res.data.data;
          if (this.tmp.vj.type == "external_personal_payment_vouchers") {
            const tmp = this.external_personal_payment_vouchers.filter(
              (value, index) => index != this.tmp.j
            );
            this.external_personal_payment_vouchers = tmp;
          }
          if (this.tmp.vj.type == "external_personal_payment_invoices") {
            const tmp = this.external_personal_payment_invoices.filter(
              (value, index) => index != this.tmp.j
            );
            this.external_personal_payment_invoices = tmp;
          }
        })
        .catch(({ error }) => {});
    },

    chargeFileVoucher(j) {
      this.deleteLoader = true;
      const url = `${actions.ACCREDITATION_PROCESS}/addFileVoucher`;
      const tmpo = this.external_personal_payment_vouchers[j];
      let formData = new FormData();
      for (const [key, value] of Object.entries(
        this.external_personal_payment_vouchers[j]
      )) {
        formData.append(key, value);
      }
      axiosPost(url, formData)
        .then((res) => {
          this.deleteLoader = false;
          if (tmpo.file) {
            const data = res.data.data[res.data.data.length - 1];
            const tmp = [...this.external_personal_payment_vouchers];
            tmp[j] = data;
            this.external_personal_payment_vouchers = tmp;
          }
        })
        .catch(({ error }) => {});
    },
    openTabExt(obj, fileName) {
      const w = window.open(obj[fileName].path, "_blank");
      w.focus();
    },

    onPay(evalTestId, inputs, toastr, pay, preloader) {
      console.log('click');
      if (!this.inputs.i_business_name ||
          !this.inputs.i_taxid ||
          !this.inputs.i_country_id ||
          !this.inputs.i_email ||
          !this.inputs.i_phone ||
          !this.inputs.i_address) {
            this.$toastr.e("Llenar el formulario Datos para Facturación");
            return ;
      }

      this.paymentCheckout = new PaymentCheckout.modal({
        
        client_app_code: 'SAE-EC-SERVER',
        client_app_key: 'q93fz5JHZVZ4zpFoxGdqJohsQyrdPR',
        // client_app_code: 'SAESTG-EC-CLIENT',
        // client_app_key: '4nYr23g8pSd5qxKEaMrJCVYwuvjwYi',
        // client_app_code: 'TESTECUADORSTG-EC-SERVER',
        // client_app_key: '67vVmLALRrbSaQHiEer40gjb49peos',
        locale: 'es', // User's preferred language (es, en, pt). English will be used by default.
        env_mode: 'prod', // `prod`, `stg`, `local` to change environment. Default is `stg`
        onOpen: function () {
          console.log('modal open');
        },
        onClose: function () {
          console.log('modal closed');
          
        },
        onResponse: function (response) { 
          console.log('modal response');

          if(response.transaction) {
            let urlTransaction = `${actions.ACCREDITATION_PROCESS}/storePaymentezTransaction`;

            const transaction = {...response };

            transaction['eval_test_id'] = evalTestId

            axiosPost(urlTransaction, transaction)
            .then((res) => {
              if (res.status == 200) {
                // console.log('tra !!');
              }
              })
              .catch(({ error }) => {});
                  

          }

          if (response.transaction && response.transaction["status_detail"] === 3) {
            preloader = true;
            console.log('Correcto !!');
            let urlPay = `${actions.ACCREDITATION_PROCESS}/storePaymentezPay`;

            const tmp = { ...inputs };
            const d = tmp.date;
            if (tmp.date) {
              tmp.date = [d.getFullYear(), d.getMonth() + 1, d.getDate()].join("-");
            }
            tmp.eval_test_id = evalTestId;
            tmp.bank_id = 3;
            tmp.transaction_type_id = 6;
            tmp.number = response.transaction.id;
            tmp.amount = response.transaction.amount;
            tmp.authorization_code = response.transaction.authorization_code;
          
            let formData = new FormData();
            for (const [key, value] of Object.entries(tmp)) {
              if (value != null) formData.append(key, value);
            }

            axiosPost(urlPay, formData)
              .then((res) => {
                if (res.status == 200) {
                  toastr.s("Transferencia realizada con exito");
                  // window.alert("Transferencia realizada con exito");
                  setTimeout(() => {
                    window.location.href = "/accreditations/process/quotation?tab=Confirmar%20Pago%20Proforma";
                  }, "2000")
                  
                } else {
                  toastr.e("Error al realizar la transferencia");
                  // window.alert("Error al realizar la transferencia");
                }
              })
              .catch(({ error }) => {}
              ).finally(() => {
          preloader = false;
        });

          } else if (response.transaction && response.transaction["status_detail"] === 9) {
            toastr.e("Transacción denegada");
          } else if (response.transaction && response.transaction["status_detail"] === 11) {
            toastr.e("Transacción rechazada por sistema de fraude");
          } else if (response.transaction && response.transaction["status_detail"] === 12) {
            toastr.e("Tarjeta en lista negra");
          } else {
            console.log('Error !!');
            toastr.e("Error al realizar la transferencia");
          }
          
        }
      });

      let i_phone = '';
      let i_email = '';
      if (this.inputs.i_phone)
        i_phone = (this.inputs.i_phone).replace('+593', '0');
      
      if (this.inputs.i_email)
        i_email = this.inputs.i_email;

        this.paymentCheckout.open({
          user_id: String(this.inputs.proform_generated.id),
          user_email: i_email, //optional
          user_phone: i_phone, //optional
          order_description: 'Pago proforma',
          order_amount: this.inputs.proform_generated.total,
          order_vat: 0,
          order_reference: 'prof-'+String(this.inputs.proform_generated.id),
          order_installments_type: pay, // optional: The installments type are only available for Ecuador and Mexico. The valid values are: https://paymentez.github.io/api-doc/#payment-methods-cards-debit-with-token-base-case-installments-type
          order_taxable_amount: 0, // optional: Only available for Ecuador. The taxable amount, if it is zero, it is calculated on the total. Format: Decimal with two fraction digits.
          order_tax_percentage: 0 // optional: Only available for Ecuador. The tax percentage to be applied to this order.
        });

    },

    initPaymentez() {
      console.log('init?');
      
    },

    nuveiReference(pay){
      let i_phone = '';
      let i_email = '';
      if (this.inputs.i_phone)
        i_phone = (this.inputs.i_phone).replace('+593', '0');
      
      if (this.inputs.i_email)
        i_email = this.inputs.i_email;

      let urlPay  = `/accreditations/paymentez/init-reference`;
      axiosPost(urlPay, {
          "locale": "es",
          "order": {
            "amount": this.inputs.proform_generated.total,
            "description": "Pago proforma",
            "vat": 0,
            "dev_reference": "prof-"+String(this.inputs.proform_generated.id),
            "installments_type": pay,
            "taxable_amount": 0,
            "tax_percentage": 0
          },
          "user": {
            "id": String(this.inputs.proform_generated.id),
            "email": i_email,
            "phone": i_phone
          }
        })
        .then((res) => {

          if (res.status === 200 && res.data.reference) {
            this.paymentCheckout.open({
              reference: res.data.reference
            });
          } else {
            this.$toastr.e("Error al generar la referencia");
          }
        })
        .catch(({ error }) => {
          console.error('Error en Nuvei:', error);
        })
        .finally(() => {
      });
    },

    openCheckout(evalTestId, inputs, toastr, pay) {
      
      if (!this.inputs.i_business_name ||
          !this.inputs.i_taxid ||
          !this.inputs.i_country_id ||
          !this.inputs.i_email ||
          !this.inputs.i_phone ||
          !this.inputs.i_address) {
            this.$toastr.e("Llenar el formulario Datos para Facturación");
            return ;
      }

      try {
        this.preloader = true;
        this.paymentCheckout = new PaymentCheckout.modal({
        //env_mode: "stg", // Cambiar a 'prod' o 'stg' según entorno
        env_mode: "prod",
        onOpen: () => {
          console.log("modal open");
        },
        onClose: () => {
          console.log("modal closed");
        },
        onResponse: (response) => {
          console.log("modal response", response);

          if(response.transaction) {
            let urlTransaction = `${actions.ACCREDITATION_PROCESS}/storePaymentezTransaction`;

            const transaction = {...response };

            transaction['eval_test_id'] = evalTestId

            axiosPost(urlTransaction, transaction)
            .then((res) => {
              if (res.status == 200) {
                // console.log('tra !!');
              }
              })
              .catch(({ error }) => {
                console.error(error);
              });        
          }

          if (response.transaction && response.transaction["status_detail"] === 3) {
            console.log('Correcto !!');
            let urlPay = `${actions.ACCREDITATION_PROCESS}/storePaymentezPay`;

            const tmp = { ...inputs };
            const d = tmp.date;
            if (tmp.date) {
              tmp.date = [d.getFullYear(), d.getMonth() + 1, d.getDate()].join("-");
            }
            tmp.eval_test_id = evalTestId;
            tmp.bank_id = 3;
            tmp.transaction_type_id = 6;
            tmp.number = response.transaction.id;
            tmp.amount = response.transaction.amount;
            tmp.authorization_code = response.transaction.authorization_code;
          
            let formData = new FormData();
            for (const [key, value] of Object.entries(tmp)) {
              if (value != null) formData.append(key, value);
            }

            axiosPost(urlPay, formData)
              .then((res) => {
                if (res.status == 200) {
                  toastr.s("Transferencia realizada con exito");
                  
                  setTimeout(() => {
                    window.location.href = "/accreditations/process/quotation?tab=Confirmar%20Pago%20Proforma";
                  }, "1000")
                  
                } else {
                  toastr.e("Error al realizar la transferencia");
                  
                }
              })
              .catch(({ error }) => {}
              ).finally(() => {});

          } else if (response.transaction && response.transaction["status_detail"] === 9) {
            toastr.e("Transacción denegada");
          } else if (response.transaction && response.transaction["status_detail"] === 11) {
            toastr.e("Transacción rechazada por sistema de fraude");
          } else if (response.transaction && response.transaction["status_detail"] === 12) {
            toastr.e("Tarjeta en lista negra");
          } else {
            console.log('Error !!');
            toastr.e("Error al realizar la transferencia");
          }
        }
      });
      } catch (error) {
        console.log(error);
        this.preloader = false;
      } finally {
        this.preloader = false;
      }
      
      //cerrar el modal
      // window.addEventListener('popstate', () => {
      //   if (this.paymentCheckout) {
      //     this.paymentCheckout.close();
      //   }
      // });

      //iniciar referencia
      this.nuveiReference(pay);
    }

  },
};
</script>